<template>
  <transition>
    <div v-if="show" class="modal-overlay">
      <ValidationObserver v-slot="{ handleSubmit }" tag="div">
        <div :class="[classes]">
          <div v-if="!hideHeader" class="modal-heading">
            <slot name="title">
              <h3 class="modal-title text-center uppercase">{{ title }}</h3>
            </slot>
            <a v-if="!hideClose"
               class="btn-close bg-white w-5 h-5 flex justify-center items-center rounded-full absolute top-1 right-1"
               href="#"
               @click.prevent="onClose">
              <i class="fa-solid fa-xmark text-red-500"></i></a>
          </div>
          <div :class="bodyClass" class="modal-body pt-4 overflow-y-auto h-auto max-h-[80vh] md:max-h-[70vh]">
            <slot :handleSubmit="handleSubmit"></slot>
          </div>
          <div v-if="!hideFooter" class="modal-footer mt-5">
            <slot name="footer">
              <div class="text-center space-x-2">
                <Button v-if="!hideOk" :is-loading="loading" class="min-w-20" size="md" variant="primary" @click="handleSubmit(onOk)">
                  {{ okText || $t("OK") }}
                </Button>
                <Button class="min-w-20" size="md" variant="white" @click="onClose">{{closeText || $t("Close") }}
                </Button>
              </div>
            </slot>
          </div>
        </div>
      </ValidationObserver>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Modal",
  props: ["title", "size", "show", "hideHeader", "hideClose", "hideFooter", "loading", "bodyClass", "okText", "closeText","hideOk"],
  computed: {
    classes() {
      return [
        "modal",
        "modal-" + (this.size || "md"),
        this.hideHeader ? "no-header" : "",
        this.hideFooter ? "no-footer" : "",
        "overflow-hidden relative"
      ]
    }
  },
  data: () => ({}),
  methods: {
    onOk() {
      this.$emit("onOk");
    },
    onClose() {
      this.$emit("update:show", false);
      this.$emit("onClose");
    }
  }
}
</script>

<style scoped>

</style>
